import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import FormHead from '@/components/common/Form/FormHead';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import {
  IAddEmployeeForm,
  IEmployeeOnBoardResponse,
} from '@/interfaces/employee.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
interface IEmployeeBankDetailsStep5Props {
  nextStep: () => void;
  empId: string | null;
}
const EmployeeBankDetailsStep5 = ({
  nextStep,
  empId,
}: IEmployeeBankDetailsStep5Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext<IAddEmployeeForm>();
  const handleNextStep = async () => {
    const isValid = await trigger([
      'bankName',
      'accountNumber',
      'accountHolderName',
      'ifscCode',
      'branchAddress',
    ]);

    if (isValid && empId) {
      setIsLoading(true);
      const formData = new FormData();
      const data = getValues();
      formData.append('bankName', data?.bankName);
      formData.append('accountNumber', data?.accountNumber);
      formData.append('accountHolderName', data?.accountHolderName);
      formData.append('ifscCode', data?.ifscCode);
      formData.append('branchAddress', data?.branchAddress);
      try {
        const response: IEmployeeOnBoardResponse = await callApi(
          API_URL + API_ENDPOINT.addEmployee + `?userId=${empId}`,
          { method: 'POST', data: formData, multipart: true },
        );
        if (response?.status) {
          showToastNotification('success', response?.message);
          nextStep();
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'message' in error) {
          showToastNotification('danger', (error as IApiErrorResponse).message);
        } else {
          showToastNotification('danger', 'Something went wrong');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12 ">
          <div className="row">
            <FormHead heading="Bank Details" />
            {/* //bank */}
            <FieldLayout fieldStyle="col-12 col-lg-6">
              {/* <label htmlFor="bankName" className="form-label">
                Bank Name <span className="text-danger">*</span>
              </label> */}
              <PrimaryInput
                errors={errors?.bankName?.message}
                label="Bank Name"
                required={true}
                id="bankName"
                placeholder="Enter bank name"
                maxLength={160}
                {...register('bankName', {
                  ...errorTypes.required('Bank Name'),
                  ...errorTypes.name,
                })}
              />
              {/* <input
                type="text"
                className="form-control"
                id="bankName"
                placeholder="Enter Bank Name"
                maxLength={160}
              /> */}
              {/* <ErrorMessage message={} /> */}
            </FieldLayout>
            {/* ac no. */}
            <FieldLayout fieldStyle="col-12 col-lg-6">
              <PrimaryInput
                errors={errors?.accountNumber?.message}
                label="Account Number"
                required={true}
                id="AccNum"
                placeholder="Enter account number"
                {...register('accountNumber', {
                  ...errorTypes.required('Account Number'),
                  ...errorTypes?.accountNumber,
                })}
              />
              {/* <label htmlFor="AccNum" className="form-label">
                Account Number <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                id="AccNum"
                placeholder="Enter Account Number"
                {...register('accountNumber', {
                  ...errorTypes.required('Account Number'),
                  ...errorTypes?.accountNumber,
                })}
              />
              <ErrorMessage message={errors?.accountNumber?.message} /> */}
            </FieldLayout>
            <FieldLayout fieldStyle="col-12 col-lg-6">
              <PrimaryInput
                errors={errors?.accountHolderName?.message}
                label="Account Holder Name"
                required={true}
                id="AccHolder"
                maxLength={160}
                placeholder="Enter account holder name"
                {...register('accountHolderName', {
                  ...errorTypes.required('Account Holder Name'),
                  ...errorTypes.name,
                })}
              />
              {/* <label htmlFor="AccHolder" className="form-label">
                Account Holder Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="AccHolder"
                maxLength={160}
                placeholder="Enter Account Holder Name"
                {...register('accountHolderName', {
                  ...errorTypes.required('Account Holder Name'),
                  ...errorTypes.name,
                })}
              /> */}
              {/* <ErrorMessage message={errors?.accountHolderName?.message} /> */}
            </FieldLayout>
            <FieldLayout fieldStyle="col-12 col-lg-6">
              <PrimaryInput
                errors={errors?.ifscCode?.message}
                label=" IFSC/RTGS Code"
                required={true}
                id="IFSC"
                placeholder="Enter ifsc/rtgs code"
                {...register('ifscCode', {
                  ...errorTypes.required('IFSC/RTGS Code'),
                  pattern: {
                    value: /^[A-Z]{4}(0[0-9]{6}|[0-9]{7})$/,
                    message: 'please enter valid IFSC/RTGS code',
                  },
                })}
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                }}
              />
              {/* <label htmlFor="IFSC" className="form-label">
                IFSC/RTGS Code <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="IFSC"
                placeholder="Enter IFSC/RTGS Code"
                {...register('ifscCode', {
                  required: 'This field is Required',
                  pattern: {
                    value: /^[A-Z0-9]*$/,
                    message: 'It must contain only numbers and letters',
                  },
                })}
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                }}
              /> */}
              {/* <ErrorMessage message={errors?.ifscCode?.message} /> */}
            </FieldLayout>
            <div className="col-12 col-lg-6">
              <div className="form-group mb-3">
                <PrimaryInput
                  errors={errors?.branchAddress?.message}
                  label="Branch Address"
                  required={true}
                  placeholder="Enter branch address"
                  //   rows={3}
                  defaultValue={''}
                  id="branchAddress"
                  //   defaultValue={''}
                  {...register('branchAddress', {
                    required: 'This field is Required',
                  })}
                />
                {/* <label htmlFor="branchAddress" className="form-label">
                  Branch Address <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="branchAddress"
                  placeholder="Enter Branch Address"
                  rows={3}
                  defaultValue={''}
                  {...register('branchAddress', {
                    required: 'This field is Required',
                  })}
                />
                <ErrorMessage message={errors?.branchAddress?.message} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <Button
          className="btn btn-primary px-4"
          type="button"
          onClick={handleNextStep}
          isLoading={isLoading}
        >
          Save and Continue
        </Button>
      </div>
    </>
  );
};
export default EmployeeBankDetailsStep5;
